import { BadgeVariant } from '../types/Badges';

export const TEXT_COLOR = '#3F465A';

export const ACCENT: Record<BadgeVariant, string> = {
  neutral: '#3F465A',
  warning: '#A16207',
  success: '#15803D',
  error: '#B91C1C',
  info: '#2561ED'
};

export const BACKGROUND: Record<BadgeVariant, string> = {
  neutral: '#191F2E14',
  warning: '#FFF5CE',
  success: '#EBFCD5',
  error: '#FFE3D6',
  info: '#D3E5FE'
};

export const DOT_BASE = 'shrink-0 w-2 h-2 rounded-full';

export const BADGE_BASE =
  'inline-flex items-center gap-1.5 rounded-md text-gray-700';
